import React from 'react';
import { Heart, Mail, Instagram, Music2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-zinc-800 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Logo & Description */}
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/4bt5sz02_nv%20logo.jpeg"
                  alt="HDMI Team Logo"
                  className="h-12 w-auto object-contain"
                />
                <div>
                  <h3 className="text-xl font-bold text-red-500">HDMI TEAM</h3>
                </div>
              </div>
              <p className="text-gray-400 text-sm">
                {t('footer_about_desc')}
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-bold mb-4">{t('footer_quick_links')}</h4>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => document.getElementById('hero').scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {t('nav_home')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('program').scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {t('nav_program')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {t('nav_gallery')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('location').scrollIntoView({ behavior: 'smooth' })}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {t('nav_location')}
                  </button>
                </li>
                <li>
                  <a
                    href="https://www.helloasso.com/associations/association-la-structure/evenements/billeterie-battle-of-the-year-next-generation"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {t('nav_reserve')}
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-white font-bold mb-4">{t('footer_contact')}</h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-2 text-gray-400 text-sm">
                  <Mail size={16} className="text-red-500" />
                  <a
                    href="mailto:asso.hmditeam@gmail.com"
                    className="hover:text-red-500 transition-colors duration-200"
                  >
                    asso.hmditeam@gmail.com
                  </a>
                </li>
                <li className="flex items-center gap-2 text-gray-400 text-sm">
                  <Instagram size={16} className="text-red-500" />
                  <a
                    href="https://instagram.com/hdm_i_team"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-red-500 transition-colors duration-200"
                  >
                    @hdm_i_team
                  </a>
                </li>
                <li className="flex items-center gap-2 text-gray-400 text-sm">
                  <Music2 size={16} className="text-red-500" />
                  <a
                    href="https://tiktok.com/@hdmi.team"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-red-500 transition-colors duration-200"
                  >
                    @hdmi.team
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-zinc-800 pt-8 mt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-500 text-sm text-center md:text-left">
                © {currentYear} {t('footer_copyright')}
              </p>
              <p className="text-gray-500 text-sm flex items-center gap-2">
                {t('footer_made_with')} <Heart size={16} className="text-red-500" fill="currentColor" /> {t('footer_for_culture')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
